class ProductAccordions extends HTMLElement {
  constructor () {
    super()

    this.itemEls = this.querySelectorAll('[data-el="product-accordions.item"]')

    this.initialiseAccordions()
  }

  initialiseAccordions () {
    this.itemEls.forEach(itemEl => {
      const triggerEl = itemEl.querySelector(
        '[data-el="product-accordions.trigger"]'
      )

      this.handleClick = this.handleClick.bind(this)

      triggerEl.addEventListener('click', this.handleClick)
    })

    this.checkOpenHeights = this.checkOpenHeights.bind(this)
    window.addEventListener('resize', this.checkOpenHeights)
  }

  checkOpenHeights () {
    this.itemEls.forEach(itemEl => {
      if (itemEl.getAttribute('aria-expanded') === 'true') {
        const bodyEl = itemEl.querySelector(
          '[data-el="product-accordions.body"]'
        )

        itemEl.style.setProperty('--Max_Height', `${bodyEl.offsetHeight}px`)
      }
    })
  }

  handleClick (event) {
    const bodyParentEl = event.currentTarget.parentNode
    const bodyEl = bodyParentEl.querySelector(
      '[data-el="product-accordions.body"]'
    )
    bodyParentEl.style.setProperty('--Max_Height', `${bodyEl.offsetHeight}px`)

    const currentState =
      event.target
        .closest('[data-el="product-accordions.item"]')
        .getAttribute('aria-expanded') === 'true'

    event.target
      .closest('[data-el="product-accordions.item"]')
      .setAttribute('aria-expanded', !currentState)
  }
}

customElements.define('product-accordions', ProductAccordions)
